module.exports = __webpack_public_path__ + "img/rss-source.9ea27146.svg";